import { render, staticRenderFns } from "./AppBottomBar.vue?vue&type=template&id=2d20b60c&scoped=true"
import script from "./AppBottomBar.vue?vue&type=script&lang=js"
export * from "./AppBottomBar.vue?vue&type=script&lang=js"
import style0 from "./AppBottomBar.vue?vue&type=style&index=0&id=2d20b60c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d20b60c",
  null
  
)

export default component.exports